import React, { useState } from 'react';
import styled from 'styled-components'

const Wrapper = styled.div`
    border-radius: 8px;
    padding: 16px 16px 0 16px;
    border: 1px solid #E4E7E7;
    min-height: 0;

    h2 {
        margin: 0;
        padding: 0;
    }

    p {
        margin: 0;
    }
`

const Title = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    p {
        color: #959D9D;
        font-size: 14px;
    }

    &:hover {
        cursor: pointer;
    }
`

const Icon = styled.img`
    width: 18px;
    height: 18px;
    margin: 0;
    padding: 0;
    margin-right: 12px;
`

const Transaction = styled.div`
    padding: 16px 0;
    border-top: 0.5px solid #CECECE;
`

const TRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
`

const T = styled.p`
    font-size: 14px;
    font-weight: 500;
    margin: 0;
    padding: 0;
    text-transform: capitalize;
`

const V = styled(T)`
    font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace;
`

const A = styled(T)`
    font-weight: 400;
    color: #626A6A;
    font-size: 12px;
`

const V2 = styled(A)`
    font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace;
    font-weight: 400;
    color: #626A6A;
    font-size: 12px;
`

const Txns = styled.div`
    display: ${(props) => props.isOpen ? 'block' : 'none'};
`

const CategoryInsightModule = ({ icon, title, transactions }) => {
    const [isOpen, setIsOpen] = useState(false)

    return (
        <Wrapper>
            <Title onClick={() => setIsOpen(!isOpen)}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Icon src={icon} alt="category" />
                    <h2 style={{ margin: 0, padding: 0}}>{title}</h2>
                </div>
                <p style={{ color: "#0080FF"}}>{transactions.length} transactions</p>    
            </Title>
            <Txns isOpen={isOpen}>
            {transactions.map((transaction) => (
                <Transaction>
                    <TRow>
                        <T>{transaction.description_normalized}</T>
                        <V>{transaction.mean_amount}</V>
                    </TRow>
                    <TRow>
                        <A>Transaction count</A>
                        <V2>{transaction.count}</V2>
                    </TRow>
                    <TRow>
                        <A>First Payment</A>
                        <V2>{transaction.start_date}</V2>
                    </TRow>
                    <TRow>
                        <A>Last Payment</A>
                        <V2>{transaction.end_date}</V2>
                    </TRow>
                    <TRow>
                        <A>Regularity</A>
                        <V2>{transaction.regularity}</V2>
                    </TRow>
                    <TRow>
                        <A>Avg. days between payments</A>
                        <V2>{transaction.mean_days_between_transactions}</V2>
                    </TRow>
                    <TRow>
                        <A>Is a recurring charge?</A>
                        <V2>{transaction.is_recurring.toLocaleString()}</V2>
                    </TRow>
                </Transaction>
            ))}
            </Txns>
        </Wrapper>
    )
}

export default CategoryInsightModule